class SheeruCart extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
  }

  updateQuantity(line, quantity) {
    // Show loading state
    document.body.style.cursor = 'wait';
    
    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: [this.sectionId]
    });

    fetch(`${routes.cart_change_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    })
    .then((response) => response.json())
    .then((parsedState) => {
      // Replace the HTML with the updated section from Shopify
      const html = new DOMParser().parseFromString(parsedState.sections[this.sectionId], 'text/html');
      const newSection = html.querySelector('sheeru-cart');
      
      this.innerHTML = newSection.innerHTML;
      
      // Update header cart bubble too
      this.updateHeaderBubble(parsedState.item_count);
      
      document.body.style.cursor = 'default';
    })
    .catch((e) => {
      console.error(e);
      document.body.style.cursor = 'default';
    });
  }

  updateHeaderBubble(count) {
    const bubbles = document.querySelectorAll('.cart-count-bubble span');
    bubbles.forEach(el => el.innerText = count);
  }
}

customElements.define('sheeru-cart', SheeruCart);